import { gql } from '@apollo/client';

const getAisleBayQuery = () => {
  const AisleBayQuery = `
    query AisleBay($storeSkuIds: [String!]!, $storeId: String!) {
      aislebay(storeSkuIds: $storeSkuIds, storeId: $storeId) {
        searchReport {
          storeId
          recordCount
        }
        storeSkus {
          storeNumber
          storeSkuId
          aisleBayInfo {
            primaryLocation
            name
            code
            invLocDesc
            bay
            aisle
          }
        }
      }
    }
`;
  return gql(AisleBayQuery);
};
export default getAisleBayQuery;
